import React from "react";
import "./App.css";
import CustomVerticalStepper from "./forms/CustomVerticalStepper";

function App() {
  return (
    <div className="App">
      {/* <h1 id="head">Registration</h1> */}
      <CustomVerticalStepper></CustomVerticalStepper>
    </div>
  );
}

export default App;
// dep check 